function Normalize() {
    return function (string) {
        return Helpers.normalizeString(string);
    };
}

angular
    .module('app')
    .filter('normalize', Normalize);
